<script>
    import { createEventDispatcher } from 'svelte';
    import { format } from 'svelte-i18n';
    let { assetTags = [], allTags = $bindable([]) } = $props();

    let formData = $state({tag: 'cancel'});

    let assetTagsIds = [];
    for (let tag of assetTags){
        assetTagsIds = [...assetTagsIds, tag.id];
    }
    allTags = allTags.filter(tag => !assetTagsIds.includes(tag.id));

    const dispatch = createEventDispatcher();

</script>
<style>
    .tag-input{
        max-width: 88%;
    }
</style>

<div class="mb-3">
    <select id='tagsSelect' name='tagsSelect'  class="form-control" style='height: 28px; clear: left; max-width: 180px;font-size: 12px; margin-right: 10px;' bind:value={formData.tag}>
        <option value='cancel'>{$format("remove")} {$format("tag")}</option>
        <option disabled>----------</option>
        {#each assetTags as tag}
            <option value={tag.id}>{tag.name}</option>
        {/each}
    </select>
</div>
<button class="btn bkg-vlsk-red btn-default mt-3" style="clear:both;" onclick={()=> dispatch("submit", formData)}>{$format("buttons.delete")}</button>
<button class="btn btn-default mt-3" style="clear:both;" onclick={()=> dispatch("cancel")}>{$format("buttons.cancel")}</button>
